<template>
  <div style="display: flex; flex: 1;">
    <div id="register-step1" class="register-step">
      <div class="register-header">
        <div></div>
        <h2 v-if="needToSubscribeToProduct">
          Completa tu registro en {{ texts.general.productname }}
        </h2>
        <h2 v-else>
          Nuevos términos y condiciones
        </h2>
        <div></div>
      </div>
      <div class="register-content">
        <p
          v-if="needToSubscribeToProduct"
          v-html="
            getText(
              'texts.register.existinguser.text1',
              'Ya tenemos tus datos médicos algun otro producto que utiliza navandu.me como servicio de registro. Sólo tienes que aceptar las condiciones de servicio para este producto'
            )
          "
          class="primary-text"
        ></p>
        <p v-else class="pb-5">
          Los términos y condiciones de {{ texts.general.productname }} han
          cambiado. Por favor consulta y acepta si estás de acuerdo los nuevos
          términos para poder continuar.
        </p>
        <div
          id="LicenciaPremiumInput-wrapper"
          v-if="showPremiumForm && needToSubscribeToProduct"
        >
          <LicenciaPremiumInput
            ref="premiumform"
            :validateOnBlur="true"
            :validateWithAuth="false"
            :previousPremiumCode="this.$store.state.register.premiumCode"
          ></LicenciaPremiumInput>
          <div style="margin-top:1em; margin-bottom:2em; text-align:center">
            <a
              class="button is-small is-light has-text-success"
              @click="validateCode"
            >
              Validar código</a
            >
          </div>
        </div>
        <div id="terms-box" v-for="term in requiredTerms" :key="term.id">
          <div class="field field-term" :type="type_productTerm">
            <b-checkbox
              type="is-success"
              @input="checkProductTerm"
              required
              ref="checkboxProductTerm"
              v-model="term.accepted"
            >
            </b-checkbox>
            <a
              class="view-terms"
              :class="type_productTerm"
              @click="viewTerms(term)"
            >
              {{ term.name }}
            </a>
          </div>

          <div class="field error-msg">
            <span v-if="showTermsError"> {{ checkboxErrorMsg }} </span>
          </div>
        </div>
      </div>
      <div class="register-button-container">
        <a
          class="button is-medium is-fullwidth is-primary"
          :class="{ 'is-loading': waitingForResponse }"
          @click="validate"
        >
          Continuar
        </a>
      </div>

      <b-modal :active.sync="isComponentModalActive" has-modal-card>
        <div class="modal-card">
          <section class="modal-card-body">
            <TermsText :htmltext="longText"> </TermsText>
          </section>
          <footer class="modal-card-foot">
            <button class="button is-success" v-on:click="accept">
              Aceptar
            </button>
            <button class="button" v-on:click="closeModal">Cerrar</button>
          </footer>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
//import Loader from '../UI/Loader.vue'
/*
Este componente  se muestra cuando un usuario hace login pero le falta información por dos motivos, 
needToSubscribeToProduct=== true: estaba registrado en otro producto navandu pero no en tok
needToSubscribeToProduct=== false: han cambiado los términos

*/
import LicenciaPremiumInput from './LicenciaPremiumInput.vue'
import TermsText from '../UI/TermsText'
import { RegisterStepMixin } from '../mixins/RegisterStepMixin'
import { ToolsMixin } from '../mixins/ToolsMixin'

export default {
  name: 'RegisterPreviousUser',
  components: {
    //Loader,
    LicenciaPremiumInput,
    TermsText
  },
  props: {
    loginData: {
      type: Object,
      required: true
    }
  },
  mixins: [RegisterStepMixin, ToolsMixin],
  data: () => ({
    isLoading: true,
    waitingForResponse: false,
    type_productTerm: '',
    terms: [],
    isComponentModalActive: false,
    currentLongText: '',
    currentReadText: null,
    checkboxErrorMsg: 'Tienes que aceptar todos los términos y condiciones',
    triedToSubmit: false,
    requiredTerms: []
  }),
  methods: {
    validate() {
      this.triedToSubmit = true
      if (this.ifFormValid() == false) return
      if (this.mandatoryPremiumCode === true) {
        // si el codigo premium es requerido
        this.$buefy.toast.open({
          duration: 5000,
          message: 'Esta aplicación requiere de un Código Premium válido',
          type: 'is-danger'
        })
        if (this.validationFinished === false) return // pero no hay código premium metido no deja continuar
      }
      //if(this.$store.state.register.statuses)
      this.$store.commit(
        'register/setServerCredentials',
        this.loginData.data.server_credentials
      )
      let groupid = this._.get(this.loginData, 'requirements.groups[0].id', '')
      this.waitingForResponse = true
      this.$store
        .dispatch('register/subscribeExistingUser', {
          terms: this.requiredTerms,
          groupid: groupid
        })
        .then(r => {
          console.log(r)
          if (this.needToSubscribeToProduct) {
            if (this.suscriptionStatus == 'SUBSCRIPTION_OK') {
              this.$store
                .dispatch('auth/login', {
                  email: this.loginData.email,
                  password: this.loginData.password
                })
                .then(() => {
                  //this.$router.push({ path: 'chat' })
                  window.location.href = this.$store.getters[
                    'decoupled/getProperConfig'
                  ].nexturl
                })
            } else if (this.suscriptionStatus == 'SUBSCRIPTION_NOT_OK') {
              this.$snackbar.open({
                message: 'Ha ocurrido un error durante el registro',
                type: 'is-danger',
                position: 'is-top',
                actionText: 'Ok',
                indefinite: true
              })
            }
          } else {
            this.$store
              .dispatch('auth/login', {
                email: this.loginData.email,
                password: this.loginData.password
              })
              .then(() => {
                //this.$router.push({ path: 'chat' })
                window.location.href = this.$store.getters[
                  'decoupled/getProperConfig'
                ].nexturl
              })
          }
          this.waitingForResponse = false
        })
        .finally(() => {})
    },
    calcRequiredTerms() {
      let allTerms1 = this._.get(
        this.loginData,
        'requirements.groups[0].terms',
        []
      )
      let allTerms2 = this._.get(this.loginData, 'requirements.terms', [])
      let allTerms = allTerms1.concat(allTerms2)

      let _requiredTerms = []

      allTerms.forEach(t => {
        if (t.accepted === false) {
          if (this._.find(allTerms, { id: t.id }) !== undefined) {
            _requiredTerms.push(t)
          }
        }
      })
      this.requiredTerms = _requiredTerms
    },
    validateCode() {
      this.$refs.premiumform.validate()
    },
    viewTerms(term) {
      this.currentLongText = term.body
      this.currentReadText = term
      this.isComponentModalActive = true
    },
    checkProductTerm() {
      //TODO adaptar esto a los términos nuevos
      let returnvalue = true
      this.requiredTerms.forEach(t => {
        returnvalue = returnvalue && t.accepted
      })
      if (returnvalue == true) this.type_productTerm = 'is-success'
      if (returnvalue == false) this.type_productTerm = 'is-danger'
      return returnvalue
    },
    closeModal() {
      this.isComponentModalActive = false
    },
    accept() {
      this.currentReadText.accepted = true
      this.closeModal()
    },
    ifFormValid() {
      var isValid = this.checkProductTerm()
      return isValid
    }
  },
  computed: {
    showTermsError: function() {
      if (this.triedToSubmit == false) return false
      if (this.requiredTerms.length > 0) {
        let returnvalue = true
        this.requiredTerms.forEach(t => {
          returnvalue = returnvalue && t.accepted
        })
        return !returnvalue
      } else return false
    },
    validationFinished() {
      return this.$store.state.register.validPremiumCode
    },
    longText: function() {
      return this.currentLongText
    },
    suscriptionStatus: function() {
      return this.$store.state.register.status
    },
    /* showPremiumForm(){
      if (this.$store.state.register.validPremiumCode === true)
        return true
      else return false
    }, */
    showPremiumForm() {
      if (!this.$store.state.decoupled.configFile) return false
      // show premium form if it is on the config file and it is not already valid
      return this.$store.state.decoupled.configFile.config.register.premiumcode
    },
    mandatoryPremiumCode() {
      return this._.get(
        this.$store.state.decoupled.configFile,
        'config.register.mandatory_premiumcode',
        false
      )
    },
    needToSubscribeToProduct() {
      if (
        this.loginData.requirements.groups &&
        this.loginData.requirements.groups[0]
      )
        return true
      else return false
    }
  },
  created() {
    //this.$store.dispatch('register/getProductTerms')
    console.log(this.loginData)
    this.calcRequiredTerms()
    //this.$store.dispatch('auth/getProfile')

    /*if (this._.isEmpty(this.$store.state.auth.loginResponse)) {
      router.replace({name: 'Home',params: { toastMsg: 'Lo sentimos tu sesión ha caducado. Necesitas volver entrar de nuevo con tu usuario y contraseña'} })
    } */
  }
}
</script>

<style lang="less">
#register-step1 {
  div.modal-background {
    background-color: rgba(255, 255, 255, 0.99);
  }
  button.modal-close:before,
  button.modal-close:after {
    background-color: #0ac6d3;
  }
  .register-forms-container {
  }
  .register-button-container {
    margin-top: 2rem;
  }

  #terms-container {
    text-align: left;
    margin-top: 4em;
  }
  .field-term {
    display: flex;
    margin-top: 16px;
  }
  a.view-terms {
    font-style: normal;
    font-weight: 300;
    line-height: 16px;
    font-size: 13px;
    /*text-decoration-line: underline;
  color: rgba(0, 0, 0, 0.6); */
  }
}
</style>
